import { render, staticRenderFns } from "./CreateGroupedSalePartsFromDraftNotification.vue?vue&type=template&id=271e3028"
import script from "./CreateGroupedSalePartsFromDraftNotification.vue?vue&type=script&lang=js"
export * from "./CreateGroupedSalePartsFromDraftNotification.vue?vue&type=script&lang=js"
import style0 from "./CreateGroupedSalePartsFromDraftNotification.vue?vue&type=style&index=0&id=271e3028&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports